<template>
    <el-dialog
        class="pay-dialog"
        :visible.sync="visible"
        :title="$t('Lesson.pay_course_setting')"
        left>
        <div class="flex pay-setting items-center">
            <div>{{ $t('Lesson.anthor') }}：</div>
            <div>{{ form.charge ? $t('Common.yes') : $t('Common.no') }}</div>
        </div>
        <div class="pay-setting">{{ $t('Lesson.choose_set') }}</div>
        <div class='pay-content'>
            <el-table
                ref="multipleTable"
                :data="storedCards"
                tooltip-effect="dark"
                style="width: 100%;"
                border
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" />
                <el-table-column :label="$t('Card.card1')">
                    <template slot-scope="{row}">{{ row.name }}</template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('Card.pay_one')" >
                    <template slot-scope="{row, $index}">
                        <el-input type="number" v-model="row.rate"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="handle-setAll flex items-center">
            <div>{{ $t('Card.setting_price') }}</div>
            <el-input class="setAll-input" type="number" v-model.number="price"></el-input>
            <div @click="handlePrice" class="save-btn">{{ $t('Common.save') }}</div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{ $t('Common.close') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('Message.confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Radio, DatePicker, Tree } from 'element-ui';

export default {
    name: 'group-setting-pay',
    components: {
        ElDialog: Dialog,
        ElRadio: Radio,
        ElTree: Tree,
        ElDatePicker: DatePicker,
    },
    data() {
        return {
            visible: false,
            id: null,
            price: null,
            form: {},
            storedCards: [],
            // 选中的储值卡id
            cardIds: [],
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.form = {};
            this.storedCards = [];
            this.cardIds = [];
        },
        open(id) {
            this.id = id;
            this.fetchStoredCards();
        },
        fetchStoredCards() {
            API.get('stored-value-card/list', {
                params: {
                    consumeWay: 2,
                },
            }).then(res => {
                if (!res || !res.length) return $ele.$message.warning('当前无储值卡支持付费团课课程~~');
                this.visible = true;
                res = res.map(el => {
                    el = Object.assign({}, el, {rate: 0});
                    return el;
                });
                this.storedCards = res;
                this.fetchData(this.id);
            });
        },
        async fetchData(id) {
            let data = null;
            await API.get(`lesson/team/${id}/rate`)
                .then(res => {
                    this.form = res;
                    data = res;
                });
            if (data.rates && data.rates.length) {
                const rows = [];
                this.storedCards = this.storedCards.map(el => {
                    data.rates.forEach(item => {
                        if (item.cardId === el.id) {
                            el = Object.assign({}, el, {rate: Number(item.rate)});
                            rows.push(el);
                        }
                    });
                    return el;
                });
                this.$nextTick(() => {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                });
            }
        },
        handleSelectionChange(val) {
            this.cardIds = val;
        },
        handlePrice() {
            this.storedCards.forEach(el => {
                this.cardIds.map(item => {
                    if (item.id === el.id) {
                        el.rate = this.price;
                    }
                    return item;
                });
            });
        },
        confirm() {
            const rates = this.cardIds.map(el => {
                el.cardId = el.id;
                delete el.name;
                delete el.id;
                return el;
            });
            // 确定
            API.put(`lesson/team/${this.id}/rate`, {
                rates: rates,
            }).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.$emit('fetchData');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.pay-dialog {
    .el-dialog {
        width: 540px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 88vh;
        overflow-y: auto;
    }
}
.pay-setting {
    margin: 0 0 20px 0;
    font-size: 12px;
}
.el-dialog--center .el-dialog__body {
    padding: 25px 25px 0 25px;
}
.handle-setAll {
    width: 100%;
    padding: 10px;
    border: 1px solid #e6e6e6;
    border-top: none;
    color: grey;
    background: #f7f7f7;
    font-size: 12px;
}
.setAll-input {
    width: 120px;
    margin: 0 10px;
}
.save-btn {
    color: #05abef;
}
</style>
